/**
 * Dependencies:
 *  - Luminous Gallery
 */

const Lightbox = {

    init: () => {
        const wrappers = document.querySelectorAll('.luminous-gallery');
        for (const wrapper of wrappers) {
            new LuminousGallery(wrapper.querySelectorAll('a'));
        }

		document.querySelectorAll('.lightbox').forEach(lightbox => {
			lightbox.addEventListener('click', function () {
				document.querySelector('html').style.overflowY = 'hidden';

				let lumLightboxOpen = document.querySelector('.lum-lightbox.lum-open');
				lumLightboxOpen.addEventListener('click', function () {
					if (lumLightboxOpen.classList.contains('lum-closing')) {
						document.querySelector('html').style.overflowY = 'unset';
					}
				}.bind(this));

				document.querySelectorAll('.lum-gallery-button').forEach(btn => {
					btn.addEventListener('click', function (e) {
						e.preventDefault();
					}.bind(this));
				});
			}.bind(this));
		});
    }

}

export default Lightbox;
